import script from "./DicListDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./DicListDialog.vue?vue&type=script&setup=true&lang=ts"

import "./DicListDialog.vue?vue&type=style&index=0&id=791c80f6&scoped=true&lang=css"

import exportComponent from "K:\\VoionContaract\\voion.contaract.clients\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-791c80f6"]])

export default __exports__